// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"a914a611ea58723c9098","293":"5daf0564df4487929939","452":"31c12c8bcf1636ab03b0","896":"8b56897d7fb87821106e"}[chunkId] + ".js";
};